<script setup>
import ResourceTableBodyColumn from "./ResourceTableBodyColumn.vue";
import { twMerge } from "tailwind-merge";

const props = defineProps({
    class: String,
});
</script>

<template>
    <tr :class="twMerge('', props.class)">
        <slot></slot>
    </tr>
</template>
